import React, { useEffect ,useState} from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { get, isEmpty } from 'lodash';
import { homeWorkDetail } from '../../../../actions/homeworkActions';
import { formatDateAndTime, checkIfBefore } from '../../../../api/dateFormat';
import PropTypes from 'prop-types';
import { Skeleton } from '@material-ui/lab';
import './styles.scss';


export default function HomeWorkDetails(props) {
  const [isFetching, setIsFetching] = useState(false);
  const dispatch = useDispatch();

  const jwtToken = useSelector((state) =>
    get(state, 'loginReducer.data.jwt', {})
  );
  const UniqueCode = props.UniqueCode;

  useEffect(() => {
    setIsFetching(true);
    homeWorkDetail(jwtToken, UniqueCode, dispatch).then(() => {
      setIsFetching(false)
    });
  }, []);

  const homeWorkDetailData = useSelector((state) =>
    get(state, 'homeworkReducer.detailData', {})
  );

  const dataToRender =
    homeWorkDetailData.length === 0 && !isEmpty(homeWorkDetailData)
      ? {}
      : {
        title: isFetching? <Skeleton width={'40%'} /> : homeWorkDetailData.HomeWorkTitle,
        date: formatDateAndTime(homeWorkDetailData.OCHDate),
        url:  homeWorkDetailData.HTMLUrl,
        };
  return (
    <div className="list-content">
      <div className="list-header">
        <p className="topic">{dataToRender.title}</p>
       
        {isFetching? <Skeleton width={'40%'} /> : !checkIfBefore(dataToRender.date, '1 Jan 2019') && (
          <p className="sub-text uppercase mt-5">{`UPLOADED on ${dataToRender.date}`}</p>
        )}
      </div>
      {isFetching ? <Skeleton height={'30px'} /> :
        <div className="iframe-responsive">
          <iframe
            width="100%"
            frameBorder="0"
            src={dataToRender.url}
            className="embed-iframe"
          />
        </div>
      }
    </div>
  );
}

HomeWorkDetails.propTypes = {
  UniqueCode: PropTypes.string,
};
